import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
import { setCurrentUser } from "utils/utils";

let env = process.env.REACT_APP_API_BASE_URL

export const couponList = async(user) => {
    const data = user || {};
    const res = await requestInstance.post(
        `${env}${API_ENDPOINT.coupon.couponList}`,data
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}

export const couponApply = async(user) => {
    const data = user || {};
    const res = await requestInstance.post(
        `${env}${API_ENDPOINT.coupon.couponRate}`,data
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}

export const couponApplyRental = async(user) => {
    const data = user || {};
    const res = await requestInstance.post(
        `${env}${API_ENDPOINT.coupon.couponRental}`,data
    )
    .catch((err) => err.response)
    return setCurrentUser(res)
}